const mpSlots = state => state.mpSlots;
const days = state => state.days;
const times = state => state.times;
const availableSlotsModalId = state => state.availableSlotsModalId;
const meetingDaysMap = state => state.meetingDaysMap;
const meetings = state => state.meetings;
const meetingDaysMapForMobile = state => state.meetingDaysMapForMobile;
const meetingSponsors = state => state.meetingSponsors;

export default {
  mpSlots,
  meetingSponsors,
  days,
  meetingDaysMap,
  meetingDaysMapForMobile,
  times,
  meetings,
  availableSlotsModalId,
};
